import Select from 'components/Select/Select'
import { ValidationErrorMessage } from 'components/Forms'
import { useFormikContext } from 'formik'
import { Alert, Form } from 'react-bootstrap'
import { IDropdownData, IOption } from 'types/baseTypes'
import { StyledSlideOutElement } from './SlideOut.styled'
import { useEffect } from 'react'

interface IProps {
  label: string
  name: string
  options: IOption<IDropdownData>[]
  onChange?: (dropdownValue: any) => void
  fallbackValue: any
  required?: boolean
  disabled?: boolean
  alertMessage?: string
  className?: string
}
// eslint-disable-next-line prettier/prettier
export const SlideOutDropdown = ({
  alertMessage,
  label,
  name,
  options,
  onChange,
  disabled = false,
  fallbackValue,
  required = false,
  className
}: IProps) => {
  const formik = useFormikContext()
  const selectedValue =
    options?.find((option) => option.value === formik?.values?.[name]) ||
    options?.find((option) => option.value === fallbackValue)

  // Set the formik value to fallback if no value is selected
  useEffect(() => {
    if (!formik.values[name] && fallbackValue && options?.length > 0) {
      const option = options.find((option) => option.value === fallbackValue)
      if (option) {
        formik.setFieldValue(name, option.value)
        onChange?.(option.value)
      }
    }
  }, [formik, name, fallbackValue, options, onChange])

  return (
    <StyledSlideOutElement className={className}>
      <Form.Label htmlFor={name} className={required && 'required'}>
        {label}
      </Form.Label>
      <Select
        inputId={name}
        name={name}
        isDisabled={disabled}
        options={options}
        value={options ? selectedValue : ''}
        onChange={(option: IOption<IDropdownData>) => {
          formik?.setFieldValue(name, option.value)
          onChange?.(option.value)
        }}
      ></Select>
      {alertMessage && (
        <Alert variant="danger" className="dropdown-alert">
          <Alert.Heading>{alertMessage}</Alert.Heading>
        </Alert>
      )}

      {formik.errors[name] && formik.touched[name] && (
        <ValidationErrorMessage>{formik.errors[name]}</ValidationErrorMessage>
      )}
    </StyledSlideOutElement>
  )
}
